export const DATA_TEST_IDS = {
  RECONCILIATIONS_SCREEN: "reconciliations-screen",
  RECONCILIATIONS_SCREEN_BODY: "reconciliations-screen-body",
  RECONCILIATIONS_TABLE: "reconciliations-table",
  RECONCILIATIONS_CARD: "reconciliations-card",
  SIDEBAR_TOGGLE: "sidebar-toggle",
};
